<template>
  <div class="audience_parts wrapper" :class="{gte_MaxJoinCount: gteMaxJoinCount}">
    <div class="inner light">
      <fa-icon icon="users-slash" v-if="gteMaxJoinCount" />
      <fa-icon icon="users" v-else />
      <span>{{ maxJoinCount }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "PersonsCount",
  props: {
    hallSlug: {
      type: String,
      required: false,
      default: ""
    },
    roomSlug: {
      type: String,
      required: false,
      default: ""
    },
    gteMaxJoinCount: {
      type: Boolean,
      required: false,
      default: false
    },
    maxJoinCount: {
      type: Number,
      required: true
    }
  }
}
</script>
